import { unitMapping } from 'lib/style';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const BaseballCornerInfielder = ({ size = 2, className }: Props) => (
  <svg
    className={className}
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.54059 9.39826L7.2438 8.7955L8.04748 9.76146L7.0197 10.6347H4.40776L3.54999 9.59145L4.10638 6.42312L5.33507 5.37988H7.89293L8.6116 6.25311L7.50654 7.18815L7.04288 6.61631H5.82192L5.40462 6.97178L5.02597 9.10461L5.26553 9.39826H6.54059ZM12.2336 6.61631H11.3063L10.8117 9.39826H11.7391L11.5227 10.6347H8.27707L8.49345 9.39826H9.42077L9.91533 6.61631H8.98802L9.20439 5.37988H12.45L12.2336 6.61631Z"
      fill="white"
    />
  </svg>
);
